import { ApiUTMEntity, ApiUTMEntityLevel, ApiClassificationItem } from "@incendium/api";

export function updateSmartLinkEntities(
  entities: ApiUTMEntity[],
  level: ApiUTMEntityLevel,
  entityId: number,
  landingPathId?: number,
  rezonateUrl?: string,
  classificationItems?: ApiClassificationItem[],
  splitCampaignId?: number | null
): ApiUTMEntity[] {
  return entities.map((entity) => {
    // Update campaign
    if (level === ApiUTMEntityLevel.CAMPAIGN && entity.externalCampaign?.id === entityId) {
      return {
        ...entity,
        externalCampaign: {
          ...entity.externalCampaign,
          landingPathId: landingPathId,
          smartLinkUrl: rezonateUrl,
          splitCampaignId: splitCampaignId !== undefined ? (splitCampaignId === null ? undefined : splitCampaignId) : entity.externalCampaign.splitCampaignId,
          classificationItems: classificationItems !== undefined ? classificationItems : entity.externalCampaign.classificationItems,
        },
      };
    }
    // Update ad group
    if (level === ApiUTMEntityLevel.AD_GROUP && entity.externalAdgroup?.id === entityId) {
      return {
        ...entity,
        externalAdgroup: {
          ...entity.externalAdgroup,
          landingPathId: landingPathId,
          smartLinkUrl: rezonateUrl,
          splitCampaignId: splitCampaignId !== undefined ? (splitCampaignId === null ? undefined : splitCampaignId) : entity.externalAdgroup?.splitCampaignId,
          classificationItems: classificationItems !== undefined ? classificationItems : entity.externalAdgroup.classificationItems,
        },
      };
    }
    // Update ad
    if (level === ApiUTMEntityLevel.AD && entity.id === entityId) {
      return {
        ...entity,
        landingPathId: landingPathId,
        rezonateUrl: rezonateUrl,
        splitCampaignId: splitCampaignId !== undefined ? (splitCampaignId === null ? undefined : splitCampaignId) : entity.splitCampaignId,
        classificationItems: classificationItems !== undefined ? classificationItems : entity.classificationItems,
      };
    }
    return entity;
  });
}

